import { combineReducers } from 'redux';


import activities       from './activities.js'  
import rewards          from './rewards.js'  
import leaderboards     from './leaderboards.js'  
import categories, {getCategory}       from './categories.js'  
import objectives       from './objectives.js'  
import cards            from './cards.js'  
import carouselItems    from './carouselItems.js'  
import announcements, {getAnnouncements}    from './announcements.js'  
import challenges, {getChallenge}     from './challenges.js'  
import userChallenges, {getHistory, getUserChallenge, getUserChallengeByCompanyAnnouncementId}   from './userChallenges.js'  
import user             from './user.js'  
import userCategories   from './userCategories.js'  
import userPlugins      from './userPlugins.js'  
import sidebar          from './sidebar.js'  
import navbar           from './navbar.js'  
import companyWelcome   from './companyWelcome.js'  
import loading          from './loading.js'  
import plugins          from './plugins.js'  
import onboarding       from './onboarding.js'  
import notifications, {getNotificationsByCategoryId}    from './notifications.js'
import objectiveCategories, {getObjectiveCategoriesByObjectiveId} from './objectiveCategories.js'
import features         from './features.js'
import alertModals      from './alertModals.js'  


/*
    NB: Reducers must be pure functions (no side effects)
*/

const combinedReducer = combineReducers({
    activities,
    rewards,
    leaderboards,
    categories,
    objectives,
    announcements,
    challenges,
    cards,
    carouselItems,
    userChallenges,
    user,
    userCategories,
    userPlugins,
    sidebar,
    navbar,
    companyWelcome,
    loading,
    plugins,
    onboarding,
    notifications,
    objectiveCategories,
    features,
    alertModals,
});

const mainReducer = (state, action) => {
    if (action.type === 'USER_SIGNOUT' || action.type==='CLEAR_STORE') {
        state = undefined;
    }
    return combinedReducer(state, action);
}

export default mainReducer;


//Composite selectors
export const getChallengeWithCategory = (state, id) => {
    var c = getChallenge(state.challenges, id);
    if(c) {
        c = {...c, category:getCategory(state.categories, c.categoryId)}
    }
    return c;
};
export const getHistoryWithChallenge = state => getHistory(state.userChallenges).map(uc => ({...uc, challenge:getChallengeWithCategory(state, uc.challengeId)}));
export const getUserChallengeWithChallenge = (state, id) => {
    var uc = getUserChallenge(state.userChallenges, id);
    if(uc) {
        uc = {...uc, challenge:getChallenge(state.challenges, uc.challengeId)};
    }
    return uc;
};
export const getAnnouncementsWithChallenge = state => {
    return getAnnouncements(state.announcements).map(a => 
                ({...a, challenge:getChallenge(state.challenges, a.challengeId), userChallenge:getUserChallengeByCompanyAnnouncementId(state.userChallenges, a.id)}));
}

export const getCategoryWithNotifications = (state, id) => {
    var category = getCategory(state.categories, id);
    if(category) {
        var notifications = getNotificationsByCategoryId(state.notifications, id);
        category = {...category, notifications:notifications};
    }
    return category;
}
export const getCategoriesByObjectiveId = (state, objectiveId) => {
    return getObjectiveCategoriesByObjectiveId(state.objectiveCategories, objectiveId).map(oc => getCategory(state.categories, oc.categoryId));
};



// WEBPACK FOOTER //
// ./src/reducers/index.js